

export default function PackExt() {
    // state

    // comportement

    // affichage
    return (
        <div className="tab-pane fade active show" id="features-tab-1">
            <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                    <h3>KIT_YCONNEKT-EXT</h3>
                    <p className="fst-italic">
                        Ce kit vous permet de couvrir une zone plus grande d'environ 1 kilomètre. Il est idéal pour les zones stratégiques comme des carrefours très fréquentés, des zones résidentielles denses, ou des campus universitaires.
                    </p>
                    <ul>
                        <li><i className="bi bi-check2-all"></i> <span>Couverture : 1 km.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Nombre de client : 300 users max.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Routeur-yconnekt.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>03 Antenne wifi.</span></li>
                    </ul>
                    <div className="pricing">
                        <div className="pricing-card">
                            <div className="price">
                                {/* <span className="currency">XAF</span> */}
                                <span className="amount">850.000</span>
                                <span className="period"> FCFA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                    <img src="/assets/imgs/pack32.jpg" alt="" className="img-fluid" />
                </div>
            </div>
        </div>
    );
}